module.exports = __webpack_public_path__ + "static/media/BEP20.980d3294.png";